import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from '../../../utils/createSignedRequest';

export const postUpdateProject = async (
  projectUpdateData,
  activeEmployerInfo = {}
) => {
  const projectId = projectUpdateData.id;
  const apiPath = `projects/${projectId}/update-project`;

  const data = {
    projectUpdateData,
  };

  const { activeEmployerId, activeEmployerBusinessId } = activeEmployerInfo;

  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    // Send the acting employer so the activity-log flush can stamp
    // employerBusinessId + gsi3 (EDIT_PROJECT route uses checkPermissions, which
    // doesn't set ctx.state.activeEmployerBusinessId). Added before signing so aws4
    // includes them in the signature.
    headers: {
      'Content-Type': 'application/json',
      ...(activeEmployerId && { 'X-Active-Employer-Id': activeEmployerId }),
      ...(activeEmployerBusinessId && {
        'X-Active-Employer-Business-Id': activeEmployerBusinessId,
      }),
    },
    body: JSON.stringify(data), // aws4 looks for body; axios for data
    data: data,
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
